export const enum myAgencyCreatorCardTrackId {
  profilePic = 'foam-myagency-creatorCard-creatorProfilePic',
  totalAudience = 'foam-myagency-creatorCard-creatorTotalAudience',
  instagramAudience = 'foam-myagency-creatorCard-creatorInstagramAudience',
  tikTokAudience = 'foam-myagency-creatorCard-creatorTikTokAudience',
  youTubeAudience = 'foam-myagency-creatorCard-creatorYouTubeAudience',
  snapchatAudience = 'foam-myagency-creatorCard-creatorSnapchatAudience',
  content = 'foam-myagency-creatorCard-creatorContent',
  selectCheckbox = 'foam-myagency-creatorCard-selectCreatorCheckbox',
  verticals = 'foam-myagency-creatorCard-creatorVerticals',
  gender = 'foam-myagency-creatorCard-creatorGender',
  bio = 'foam-myagency-creatorCard-creatorBio',
}
